export function isDevelopmentMode() {
    return process.env.NODE_ENV === 'development';
}
export function shouldDebugOptionUpdates() {
    return isDevelopmentMode() && process.env.DEBUG_ECHARTS_OPTION_UPDATES === 'true';
}

//# sourceMappingURL=env.js.map